import { css } from 'styled-components'

export const blockTitleStyles = css`
  ${({ theme }) => theme.getTypography('desktop', 'title', 'title4')}

  margin-bottom: ${({ theme }) => theme.spaces[3]}px;
  text-transform: unset;

  ${({ theme }) => theme.below.mobileL`
    ${theme.getTypography('mobile', 'title', 'title4')}
  `}
`

export const blockWapperStyles = css`
  &:last-child {
    margin-bottom: 0;
  }
`
